<div class="container" fxLayout="row" fxLayout.lt-md="column">
  <fal-regional-helpline
    [fxFlex]="!myProviders ? 100 : 60"
    *ngIf="regionalHelplines"
    [phoneNumbers]="regionalHelplines.phones"
    [heading]="regionalHelplinesHeading"
    fxFlexAlign="center"
    class="helpline"
  ></fal-regional-helpline>
  <div class="divider" *ngIf="regionalHelplines && myProviders" fxShow fxHide.lt-sm></div>
  <div class="divider horizontal" *ngIf="regionalHelplines && myProviders" fxHide fxShow.lt-sm></div>
  <fal-my-providers
    [fxFlex]="!regionalHelplines ? 100 : 40"
    *ngIf="myProviders"
    [link]="myProviders.link"
    [target]="myProviders.target"
    fxFlexAlign="center"
  ></fal-my-providers>
</div>
